import * as React from 'react';
import { Link } from 'react-router-dom';
import { RouteDefinitions, getRoute } from '@common/route-definitions';

export class Breadcrumbs extends React.Component {
  private location: string;
  private id?: string | number;
  private isEdit: boolean;
  private isCreate: boolean;
  private isValid: boolean = false;
  private swoCreate: boolean;
  private isBalance: boolean;
  private isSearch: boolean;

  componentWillMount() {
    if (!((window || {}).location || {}).pathname) {
      return;
    }
    var route = window.location.pathname;
    var parts = route.split('/');
    if (parts.length < 2) {
      return;
    }
    this.location = parts[1].replace(/-/gi, '');
    this.id = undefined;
    if (parts.length >= 3) {
      this.id = parts[2];
      if (parseFloat(this.id) !== 0) {
        this.id = +this.id;
      }
    }
    this.swoCreate = typeof this.id === 'number' && parts.indexOf('swo') >= 0 && parts.indexOf('contract') >= 0;
    this.isBalance = !this.swoCreate && typeof this.id === 'number' && parts.indexOf('balances') > 0;
    this.isSearch = !this.swoCreate && !this.isBalance && parts.indexOf('search') > 0;
    this.isEdit =
      !this.isBalance &&
      !this.swoCreate &&
      !this.isSearch &&
      typeof this.id === 'number' &&
      parts.indexOf('details') < 0;
    this.isCreate = !this.swoCreate && typeof this.id === 'undefined' && parts.indexOf('details') < 0;
    this.isValid = true;
  }

  renderEnding = () => {
    if (!this.isSearch) {
      if (this.isEdit) {
        return (
          <>
            <i className="fas fa-caret-right red-text" />
            <Link to={getRoute(RouteDefinitions[this.location].Details, { id: +this.id! })}>
              <h3 className="red-text">&nbsp; {RouteDefinitions[this.location].Title} Detail</h3>
            </Link>
            <i className="fas fa-caret-right red-text" />
            <h3>&nbsp;Edit {RouteDefinitions[this.location].Title}</h3>
          </>
        );
      } else if (this.isCreate) {
        return (
          <>
            <i className="fas fa-caret-right red-text" />
            <h3>&nbsp;Create {RouteDefinitions[this.location].Title}</h3>
          </>
        );
      } else if (this.swoCreate) {
        return (
          <>
            <i className="fas fa-caret-right red-text" />
            <h3>&nbsp;Create SWO</h3>
          </>
        );
      } else if (this.isBalance) {
        return (
          <>
            <i className="fas fa-caret-right red-text" />
            <h3>&nbsp;Make a Payment</h3>
          </>
        );
      }

      return (
        <>
          <i className="fas fa-caret-right red-text" />
          <h3>&nbsp; {RouteDefinitions[this.location].Title} Detail</h3>
        </>
      );
    }
    return <></>;
  };

  renderMiddle = () => {
    if (this.swoCreate || this.isBalance) {
      return (
        <>
          <Link to={getRoute(RouteDefinitions[this.location].Details, { id: +this.id! })}>
            <h3 className="red-text">&nbsp; {RouteDefinitions[this.location].Title}</h3>
          </Link>
        </>
      );
    } else {
      return (
        <>
          <Link to={RouteDefinitions[this.location].Search}>
            <h3 className="red-text">&nbsp; {RouteDefinitions[this.location].Title}s</h3>
          </Link>
        </>
      );
    }
  };

  render() {
    if (!this.isValid) {
      return null;
    }
    return (
      <div className="row middle-xs mb-10 pb-10">
        <Link to={RouteDefinitions.root}>
          <h3 className="red-text">Dashboard</h3>
        </Link>
        <i className="fas fa-caret-right red-text" />
        {this.renderMiddle()}
        {this.renderEnding()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/breadcrumbs/breadcrumbs.tsx